import {Component} from '@angular/core';
import {AsyncPipe} from '@angular/common';
import {ProductService} from 'src/app/shared/services/product.service';
import {genericErrorObserver} from 'src/app/shared/observables/generic-error.observer';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

/**
 * Outputs the product name.  For use in text blocks.
 *
 * <p>Welcome to <app-product-name />!</p>
 */

@Component({
    selector: 'app-product-name',
    imports: [AsyncPipe],
    template: '{{ productName$ | async }}',
    styles: ':host { display: inline }'
})
export class ProductNameComponent {

  productName$: Observable<string>;

  constructor(productService: ProductService) {
    if (!productService.wasDataFetched) {
      productService.fetch().subscribe(genericErrorObserver);
    }

    this.productName$ = productService.get().pipe(
      map(p => p.name),
    );
  }

}
